var contactmodal = {
  eyebrow: "Contact",
  heading: "Get in touch",
  intro: "Get in touch with us for commission details and general inquiries.",
  closeLabel: "Close contact information",
  roles: {
    redemptionCoordinator: "Redemption Coordinator",
    businessDevelopment: "Senior Business Development Manager",
  },
};

module.exports = contactmodal;
